import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import swal from 'sweetalert';
import GoBackButton from '../../../components/GoBackButton';
import axiosInstance from '../../../services/AxiosInstance';

const EmployerProfile = () => {

    const { id } = useParams();

    const [employer, setEmployer] = React.useState({});
    const [desc, setDesc] = React.useState();

    useEffect(() => {
        axiosInstance.get(`/institution/${id}`).then(res => {
            setEmployer(res.data)
            setDesc(res.data.joc_description)
        });
        // eslint-disable-next-line
    }, []);

    const handleSubmit = () => {
        axiosInstance("institution/" + id + "/", { method: "PATCH", data: { "joc_description": desc } })
            .then(res => { if (res.status === 200) swal("", "Updated successfully", "success", { button: "Ok!", }) })
    }

    return (
        <div className="page-content bg-white">
            <div className="content-block">
                <div className="section-full bg-white p-b20">
                    <div className="ml-3 mr-1">
                        <div className="page-content bg-white">
                            <div className="content-block">
                                <div className="section-full bg-white p-b20">
                                    <div className="container">
                                        <div className="job-bx browse-job clearfix ">
                                            <div class="d-flex justify-content-between mb-3">
                                                <div className="h5 font-weight-bold">{employer?.emp_details?.name} </div>
                                                <div>
                                                    <GoBackButton />
                                                </div>
                                            </div>
                                            <div class="container mb-3">
                                                <div className="mt-3 mb-3 container bootstrap snippets bootdey">
                                                    <div className="panel-body inf-content">
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <img alt="" style={{ width: "600px" }} className="img-circle img-thumbnail isTooltip" src={employer?.emp_details?.pimg} data-original-title="Usuario" />
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="table-responsive">
                                                                    <table className="table table-user-information">
                                                                        <tbody>
                                                                            <tr>
                                                                                <td>Name</td>
                                                                                <td className="text-primary">
                                                                                    {employer?.emp_details?.name}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td> Username </td>
                                                                                <td className="text-primary">
                                                                                    {employer?.emp_details?.username}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td> Company Name </td>
                                                                                <td className="text-primary">
                                                                                    {employer?.company_name}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td> Phone Number </td>
                                                                                <td className="text-primary">
                                                                                    +{employer?.mobile}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td> Email </td>
                                                                                <td className="text-primary">
                                                                                    {employer?.emp_details?.email}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td> Founded Date </td>
                                                                                <td className="text-primary">
                                                                                    {employer?.founded_date}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td> Address </td>
                                                                                <td className="text-primary">
                                                                                    {employer?.city?.name}, {employer?.state?.name}, {employer?.country?.name} - {employer?.zipcode}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td> Website </td>
                                                                                <td className="text-primary">
                                                                                    <a href={employer?.website || ""} target="_blank" rel="noopener noreferrer">{employer?.website}</a>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                    <div class="d-flex justify-content-between p-2">
                                                                        <textarea
                                                                            className="form-control w-75"
                                                                            rows="5"
                                                                            value={desc}
                                                                            onChange={e => setDesc(e.target.value)}
                                                                            placeholder="About this Employer"
                                                                        ></textarea>
                                                                        <button className="btn btn-sm btn-success mt-2" onClick={handleSubmit}>Update</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmployerProfile;